import styled from "styled-components";

export const StyledHideSomeInfo = styled.div`
  height: 45px;
  display: inline-flex;
  align-items: center;
  grid-gap: 5px;
  white-space: nowrap;
`;
